export const DIFFERENT_RESTAURANT_ERROR = () => { return new Error("Different restaurnt") };
export const INVALID_MENU = () => { return new Error("Menu Is Broken") };
export const SOLD_OUT_ITEMS_FOUND = () => { return new Error("There are sold out menu items in your cart") };